type RetryOptions = {
  attempts?: number;
  delayMs?: number;
};

function wait(milliseconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

// Runs an async operation and retries it on rejection, using linear backoff
// between attempts. The last error is rethrown once all attempts are exhausted,
// so callers can still distinguish a real failure from a successful empty result.
export async function retryAsync<T>(
  operation: () => Promise<T>,
  { attempts = 3, delayMs = 400 }: RetryOptions = {},
): Promise<T> {
  let lastError: unknown;

  for (let attempt = 1; attempt <= attempts; attempt++) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;

      if (attempt < attempts) {
        await wait(delayMs * attempt);
      }
    }
  }

  throw lastError;
}
